import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import axios from 'axios';
import urlBase from '../../../url-base';
import Snackbar from 'material-ui/Snackbar';
import { FaStepBackward } from "react-icons/fa";
import { Colors, Styles, tableStyles } from '../../../styles/theme';
import Grid from '@material-ui/core/Grid';
import InputMask from 'react-input-mask';
import LookupHelper from '../../../util/LookupHelper';
import Paper from '@material-ui/core/Paper';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

class VendasPorVendedor extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      dataInicio: '',
      carregandoDados: false,
      mensagemErro: null,
      resultados: [],
      snackbar: {
        open: false,
        msg: ''
      },
    resultadosTabela: [],
    colunasStatus: [],
    filtroVendedor: '',
    dataFim: '',

    dialogAberto: false,
    vendedorSelecionado: null,
    dataSelecionada: null,
    salesmanIdSelecionado: null,
    vendasDetalhadas: [],
    modoTela: 'LISTA', 
    dialogVendaAberto: false,
    vendaSelecionada: null,
    disabledInput: true,

    cacheMunicipios: {}, // { [idMunicipio]: 'Nome do Município' }
    cacheUFs: {},        // se precisar
    cachePlanos: {},     // exemplo para outros domínios
    pendencyList: [],

    paginaAtual: 1,
    itensPorPagina: 15

    

    };


    this.buscarRelatorio = this.buscarRelatorio.bind(this);
    this.buscarVendasDetalhadas = this.buscarVendasDetalhadas.bind(this);
    this.abrirDialogDetalheVenda = this.abrirDialogDetalheVenda.bind(this);
    this.fecharDialogVenda = this.fecharDialogVenda.bind(this);
    this.styles = {
      table:{
        tableConfig:{
          ontFamily: "RubikRegular",
          textTransform: "uppercase",
        },
        theadTr:{
          fontFamily: "Sora",
          textTransform: "uppercase",
        }
      },
      iconTop:{
        paddingTop:5,
        marginRight: 0        
      },      
      error: {
        textAlign: 'center',
        fontSize: 18,
        color:'#a8243e',
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      zero: {
        textAlign: 'center',
        fontSize: 18,
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      modal: {
        width: '85%',
        maxWidth: 'none',
      },
      fieldset: {
        border: '1px solid #f5aa00',
        padding: 10,
        marginTop: 15,
        paddingBottom: 25,
        borderRadius: 5
      },
      legend: {
        width: 'auto',
        fontSize: 20,
        position: 'relative',
        marginLeft: 15,
        padding: '0 5px'
      },
      input: {
        width: '100%'
      },
      label: {
        margin: 5,
        color: '#545454'
      },
      col: {
        marginTop: 0,
        paddingBottom: 0
      },
      doc: {
        width: 150,
        height: 100,
        padding: '.25rem',
        backgroundColor: '#fff',
        border: '1px solid #dee2e6',
        borderRadius: '.25rem',
        cursor: 'pointer'
      },
      docPdf: {
        width: 150,
        height: 100,
        padding: '.25rem',
        backgroundColor: '#fff',
        cursor: 'pointer',
        marginTop: 5
      },
      titleDoc: {
        margin: 0
      },
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        bottom: 15,
        left: 5
      },
      penEdit: {
        cursor: 'pointer',
        padding: 10
      }
    };
  }
  componentDidMount() {
    const userId = localStorage.getItem('dental_u');
    const perfil = localStorage.getItem('dental_y');

    if (perfil === 'SALESMAN' && userId) {
      axios.get(`${urlBase.loopBack}Salesmans/findOne`, {
        params: {
          filter: {
            where: { userId }
          }
        }
      })
      .then(res => {
        if (res.data && res.data.id) {
          this.setState({ loggedSalesmanId: res.data.id });
        } else {
          console.warn('Vendedor não encontrado para o usuário:', userId);
        }
      })
      .catch(err => {
        console.error('Erro ao buscar vendedor pelo userId', err);
      });
    }
    // pega lista de pendências
    axios.get(`${urlBase.loopBack}Pendencies`)
      .then(res => {
        if (res.data && res.data.id) {
          this.setState({ pendencyList: res.data });
        } else {
          console.warn('Lista de pendência não encontrada');
        }
      })
      .catch(err => {
        console.error('Erro ao buscar Lista de pendência', err);
      });
  }
  snackbarRequestClose() {
    let state = this.state;
    state.snackbar.open = false;
    state.snackbar.msg = '';
    this.setState(state);
  }

  goBack() {
    window.history.back();
  }

  buscarRelatorio() {
    if (!this.state.dataInicio) {
      this.setState({ mensagemErro: 'Informe a data inicial.' });
      return;
    }

    const isSalesman = localStorage.getItem('dental_y') === 'SALESMAN';
    const salesmanId = this.state.loggedSalesmanId;

    this.setState({
      carregandoDados: true,
      mensagemErro: null
    });

    const params = {
      dataInicio: this.state.dataInicio
    };

    if (this.state.dataFim) {
      params.dataFim = this.state.dataFim;
    }

    // ✅ agora o salesmanId é REAL
    if (isSalesman && salesmanId) {
      params.salesmanId = salesmanId;
    }

    axios.get(`${urlBase.loopBack}sales/vendas-por-vendedor`, { params })
      .then(res => {
    
      console.log(
        'PRIMEIRO ITEM DA API vendas por vendedor:',
        res.data && res.data.length ? res.data[0] : undefined
      );


        const dadosApi = res.data || [];
        const tabela = this.normalizarDadosTabela(dadosApi);

        this.setState({
          resultadosTabela: tabela.linhas,
          colunasStatus: tabela.status,
          carregandoDados: false,          
          paginaAtual: 1

        });
      })
      .catch(err => {
        console.error(err);
        this.setState({
          carregandoDados: false,
          mensagemErro: 'Erro ao buscar relatório.'
        });
      });
  }

agruparPorData() {
  return this.state.resultados.reduce((acc, item) => {
    if (!acc[item.data]) {
      acc[item.data] = [];
    }
    acc[item.data].push(item);
    return acc;
  }, {});
}
normalizarDadosTabela(dados) {
  const mapa = {};
  const statusSet = new Set();

  if (!Array.isArray(dados)) {
    return { linhas: [], status: [] };
  }

  dados.forEach(item => {
    // 🔒 Blindagem dos campos principais
    const data = item.data || 'SEM_DATA';
    const vendedor = item.vendedor || 'SEM_VENDEDOR';
    const status = item.status || 'SEM_STATUS';
    const quantidade = Number(item.quantidade) || 0;

    const chave = `${data}__${vendedor}`;

    // ✅ registra status dinamicamente
    statusSet.add(status);

    // ✅ cria a linha se ainda não existir
    if (!mapa[chave]) {
      mapa[chave] = {
        data: data,
        vendedor: vendedor,
        salesmanId: item.salesmanId,
        total: 0
      };
    }

    // ✅ soma corretamente por status
    mapa[chave][status] = (mapa[chave][status] || 0) + quantidade;

    // ✅ soma total da linha
    mapa[chave].total += quantidade;
  });

  // ✅ transforma em array
  const linhas = Object.values(mapa);

  // ✅ ordenação opcional (data DESC, vendedor ASC)
  linhas.sort((a, b) => {
    if (a.data < b.data) return 1;
    if (a.data > b.data) return -1;
    return a.vendedor.localeCompare(b.vendedor);
  });

  return {
    linhas: linhas,
    status: Array.from(statusSet).sort()
  };
}
renderTabelaUnica() {

  const { resultadosTabela, colunasStatus, paginaAtual, itensPorPagina } = this.state;

  const filtro = this.state.filtroVendedor.toLowerCase();

  const linhasFiltradas = resultadosTabela.filter(linha =>
    linha.vendedor &&
    linha.vendedor.toLowerCase().includes(filtro)
  );


    const totalPaginas =
      Math.ceil(linhasFiltradas.length / itensPorPagina) || 1;

    const paginaSegura =
      paginaAtual > totalPaginas ? 1 : paginaAtual;

    const inicio = (paginaSegura - 1) * itensPorPagina;
    const fim = inicio + itensPorPagina;


  const linhasPaginadas = linhasFiltradas.slice(inicio, fim);

  const totais = this.calcularTotaisGerais(linhasFiltradas);

    if (!resultadosTabela.length) {
      return <p style={{ fontSize: '13px', color: '#888' }}>Nenhum resultado.</p>;
    }
    return (
      <div  className="responsive-table-wrapper">
        <table id="table_id" 
          className="dataTable table-striped"
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '13px'
          }}

        >
          <thead>
            <tr>
              <th style={styles.th}>DATA</th>
              <th style={styles.th}>VENDEDOR</th>

              {colunasStatus.map(status => (
                <th key={status} style={styles.th}>
                  {status}
                </th>
              ))}

              <th style={styles.th}>Total</th>
            </tr>
          </thead>

          <tbody>
              {linhasPaginadas.map((linha, idx) => (
                <tr key={idx} className="row_table">
                  
                  <td style={styles.td} data-label="Data">
                    {this.formatarDataParaBR(linha.data)}
                  </td>


                  <td style={styles.td} data-label="Vendedor">
                    <span
                      style={{ color: '#2563eb', cursor: 'pointer', fontWeight: 'bold' }}
                      onClick={() =>
                        this.abrirVendasDoVendedor(linha)
                      }
                    >
                      {linha.vendedor}
                    </span>
                  </td>


                  {colunasStatus.map(status => (
                    <td key={status} style={styles.td} data-label="Status">
                      {linha[status] || 0}
                    </td>
                  ))}

                  <td style={{ ...styles.td, fontWeight: 'bold' }} data-label="Total">
                    {linha.total}
                  </td>
                </tr>
              ))}
              <tr 
                  style={{ backgroundColor: '#a8243e', 
                  color : '#fff', 
                  fontSize : '30px', 
                  fontWeight: 'bold' }}>
              <td style={styles.td}>TOTAL</td>
              <td style={styles.td}>—</td>

              {colunasStatus.map(status => (
                <td key={status} style={styles.td}>
                  {totais[status]}
                </td>
              ))}

              <td style={styles.td}>
                {totais.totalGeral}
              </td>
              </tr>
          </tbody>
        </table>
        {/** Botões de paginação */}
        <div style={{
          display: 'flex', 
          justifyContent: 'center', 
          gap: 10, 
          marginTop: 15 
        }}>
          <button
            disabled={paginaAtual === 1}
            onClick={() => this.setState({ paginaAtual: paginaAtual - 1 })}
          >
            ⬅ Anterior
          </button>

          <span style={{ fontWeight: 'bold' }}>
            Página {paginaAtual} de {totalPaginas}
          </span>

          <button
            disabled={paginaAtual === totalPaginas}
            onClick={() => this.setState({ paginaAtual: paginaAtual + 1 })}
          >
            Próxima ➡
          </button>
        </div>        
      </div>
    );
}

calcularTotaisGerais(linhas) {
  const { colunasStatus } = this.state;

  const totais = {
    totalGeral: 0
  };

  colunasStatus.forEach(status => {
    totais[status] = 0;
  });

  linhas.forEach(linha => {
    colunasStatus.forEach(status => {
      totais[status] += Number(linha[status] || 0);
    });

    totais.totalGeral += Number(linha.total || 0);
  });

  return totais;
}
exportarCSV() {
  const { resultadosTabela, colunasStatus } = this.state;

  if (!resultadosTabela.length) {
    alert('Nenhum dado para exportar.');
    return;
  }

  // Cabeçalho
  let csv = ['Data', 'Vendedor', ...colunasStatus, 'Total'].join(';') + '\n';

  // Linhas
  resultadosTabela.forEach(linha => {
    const row = [
      linha.data,
      `"${linha.vendedor}"`
    ];

    colunasStatus.forEach(status => {
      row.push(linha[status] || 0);
    });

    row.push(linha.total);

    csv += row.join(';') + '\n';
  });

  // Download
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', 'vendas_por_vendedor.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
formatarDataParaBR(data) {
  if (!data || typeof data !== 'string') return data;

  // 1. Limpeza para o formato do Mongo:
  // Se contiver 'T', pegamos apenas o que vem antes (a data)
  // Se não contiver 'T', o dataLimpa será a própria string original (AAAA-MM-DD)
  let dataLimpa = data.includes('T') ? data.split('T')[0] : data;

  // 2. Divide a string pelas separações comuns (- ou /)
  const partes = dataLimpa.split(/[-\/]/);

  // 3. Validação: Se não houver 3 partes (Ano, Mês, Dia), não é uma data tratável
  if (partes.length !== 3) return data;

  const [ano, mes, dia] = partes;

  // 4. Retorno formatado (garantindo que o dia tenha apenas 2 dígitos)
  return `${dia.substring(0, 2)}/${mes}/${ano}`;
}
abrirVendasDoVendedor(vendedor) {
  this.setState({
    modoTela: 'DETALHE',
    dialogAberto: true,
    dataSelecionada: vendedor.data,
    vendedorSelecionado: vendedor,
    salesmanIdSelecionado: vendedor.salesmanId   // ✅ TEM QUE ESTAR AQUI
  }, () => {
    this.buscarVendasDetalhadas();
  });
}
buscarVendasDetalhadas() {
  const { vendedorSelecionado } = this.state;

  this.setState({ carregandoDetalhes: true });

  axios.get(`${urlBase.loopBack}sales/vendas-por-vendedor-dia`, {

      params: {
        data: vendedorSelecionado.data,
        salesmanId: vendedorSelecionado.salesmanId  // ✅ OBRIGATÓRIO
      }

  })
  .then(res => {
    console.log('RETORNO API:', res.data);
    this.setState({
      vendasDetalhadas: res.data || [],
      carregandoDetalhes: false
    });
  })
  .catch(err => {
    console.error(err);
    this.setState({ carregandoDetalhes: false });
  });
}

renderTabelaVendasDetalhadas() {
  const {
    dialogAberto,
    vendasDetalhadas,
    carregandoDetalhes,
    vendedorSelecionado,
    //dataSelecionada
  } = this.state;

  if (!dialogAberto) return null;

  if (carregandoDetalhes) {
    return <p>🔄 Buscando vendas do vendedor...</p>;
  }

  if (!vendasDetalhadas.length) {
    return <p>Nenhuma venda encontrada para este vendedor.</p>;
  }

  return (
    <div style={{ marginTop: '25px' }}>

      <button
        onClick={() => this.voltarParaLista()}
        style={{
          ...Styles.buttonSuccess,
          backgroundColor: '#475569',
          marginBottom: '50px'
        }}
      >
        ← Voltar para a pesquisa
      </button>

      <h4>
        Vendas de 
        <strong
          style={{ color: '#1565c0', fontSize : '18px',  padding: '8px', borderRadius: '4px' }}

        >{vendedorSelecionado.vendedor}</strong> em{' '}
        <strong 
        style={{ color: '#721c24', fontSize : '20px', backgroundColor: '#f8d7da', padding: '8px', borderRadius: '4px' }}
        >
            {this.formatarDataParaBR(vendedorSelecionado.data)}
        </strong>
      </h4>
      <Paper style={{overflow: 'auto', boxShadow:"none", marginLeft: 10, marginTop: 20,borderRadius:0}}>

            <table id="table_id" className="table-striped" style={{width:'100%'}}>

              <thead>
                <tr>
                  <th >Data</th>
                  <th >Corretora</th>
                  <th >Vendedor</th>
                  <th >Responsável</th>
                  <th >CPF</th>
                  <th >Plano</th>
                  <th >Vidas</th>
                  <th >Valor Plano</th>
                  <th >Venda</th>
                  <th >Status</th>
                </tr>
              </thead>
              <tbody>
                {vendasDetalhadas.map((venda, index) => (
                  <tr 
                        id={'row_sales_' }
                        key={index}
                        className="row_table"
                        onClick={() => this.abrirDialogDetalheVenda(venda)}
                        style={{ cursor: 'pointer' }}                  
                  >

                    <td data-label="Data">
                      {this.formatarDataParaBR(venda.created)}
                    </td>

                    <td data-label="Corretora">
                      {venda.broker && venda.broker.user
                        ? venda.broker.user.name
                        : '—'}
                    </td>

                    <td data-label="Vendedor">
                      {venda.salesman && venda.salesman.user
                        ? venda.salesman.user.name
                        : '—'}
                    </td>

                    <td data-label="Resp. Financeiro">
                      {venda.financialManager
                        ? venda.financialManager.firstName
                        : '—'}
                    </td>

                    <td data-label="CPF">
                      {venda.financialManager
                        ? venda.financialManager.cpf
                        : '—'}
                    </td>

                    <td data-label="Plano">
                      {venda.financialManager &&
                      venda.financialManager.plans
                        ? venda.financialManager.plans.name
                        : '—'}
                    </td>

                    <td data-label="Vidas">
                      {venda.financialManager.dependents.length || 0}
                    </td>

                    <td data-label="Valor">
                      {venda.financialManager &&
                      venda.financialManager.plans
                        ? venda.financialManager.plans.value
                        : '—'}
                    </td>
                    <td data-label="Vendas">
                      {venda.tipoVenda}
                    </td>
                    <td data-label="Status">


  <span
    style={{
      padding: '6px 14px',
      borderRadius: '20px',
      fontSize: '11px',
      fontWeight: 'bold',
      textTransform: 'uppercase',

      backgroundColor:
        venda.status && statusStyles[venda.status]
          ? statusStyles[venda.status].bg
          : '#eee',

      color:
        venda.status && statusStyles[venda.status]
          ? statusStyles[venda.status].color
          : '#555'
    }}

                          >                  
                      {venda.status}
                      </span>
                    </td>

                  </tr>
                ))}
              </tbody>
          </table>
          </Paper>
    </div>
  );
}
voltarParaLista() {
  this.setState({
    modoTela: 'LISTA',
    vendedorSelecionado: null,
    dataSelecionada: null,
    salesmanIdSelecionado: null,
    vendasDetalhadas: []
  });
}


abrirDialogDetalheVenda(venda) {
  // Abre o modal imediatamente (UX melhor)
  this.setState({
    dialogVendaAberto: true,
    vendaSelecionada: {
      ...venda,
      endereco: null
    }
  });
  // Busca endereço completo pelo CEP
  LookupHelper.obterEnderecoPorCep(venda.financialManager.cep)
    .then(endereco => {
      console.log('ENDERECO RETORNADO PELO HELPER:', endereco);
      this.setState(prevState => ({
        vendaSelecionada: {
          ...prevState.vendaSelecionada,
          endereco
        }
      }));
    })
    .catch(err => {
      console.error('Erro ao obter endereço por CEP:', err);

      this.setState(prevState => ({
        vendaSelecionada: {
          ...prevState.vendaSelecionada,
          endereco: null
        }
      }));
    });
}
renderDialogDetalheVenda() {
  const { dialogVendaAberto, vendaSelecionada } = this.state;

  const endereco = vendaSelecionada
    ? vendaSelecionada.endereco
    : null;

  if (!dialogVendaAberto || !vendaSelecionada) return null;
  const actions = [
    <FlatButton
      label="Fechar"
      primary={true}
      onClick={() => this.fecharDialogVenda()}
    />
  ];


const dependents =
  vendaSelecionada &&
  vendaSelecionada.financialManager &&
  vendaSelecionada.financialManager.dependents
    ? vendaSelecionada.financialManager.dependents
    : [];

const titular = dependents.find(function (d) {
  return d.isHolder === true;
});

const outrosDependentes = dependents.filter(function (d) {
  return d.isHolder === false;
});


  return (
    <Dialog
      title="Detalhes da Venda"
      actions={actions}
      contentStyle={{
        width: '80%',
        maxWidth: '1200px'
      }}
      autoScrollBodyContent={true}
      modal={false}
      open={dialogVendaAberto}
      onRequestClose={() => this.fecharDialogVenda()}
    >
          <fieldset style={this.styles.fieldset}>
            
            <legend style={this.styles.legend}>
              Responsável Financeiro
            </legend>

            <Grid container spacing={24}>
              
              <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                <label style={this.styles.label} htmlFor="fm_firstName">Nome </label>
                <Input
                  id="fm_firstName"
                  style={this.styles.input}
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.firstName}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={6}>
                <label style={this.styles.label} htmlFor="fm_susNumber" >Cartão SUS</label>
                <Input
                  id="fm_susNumber"
                  style={this.styles.input}
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.susNumber}
                />
              </Grid>
          
              <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                <label style={this.styles.label} htmlFor="fm_homePhone" >Telefone Resid.</label>
                <InputMask
                  id="fm_homePhone"
                  style={this.styles.input}
                  className="form-control"
                  mask="(99) 9999-9999"
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.homePhone}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                <label style={this.styles.label} htmlFor="fm_cellPhone" >Celular 1</label>
                <InputMask
                  id="fm_cellPhone"
                  style={this.styles.input}
                  mask="(99) \9 9999-9999"
                  className="form-control"
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.cellPhone}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                <label style={this.styles.label} htmlFor="fm_cellPhone2">Celular 2</label>
                <InputMask
                  id="fm_cellPhone2"
                  style={this.styles.input}
                  mask="(99) \9 9999-9999"
                  className="form-control"
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.cellPhone2}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                <label style={this.styles.label} htmlFor="fm_email">Email</label>
                <Input
                  id="fm_email"
                  style={this.styles.input}
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.email}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                <label style={this.styles.label} htmlFor="fm_motherName">Nome da Mãe</label>
                <Input
                  id="fm_motherName"
                  style={this.styles.input}
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.motherName}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                <label style={this.styles.label} htmlFor="fm_rg">RG</label>
                <Input
                  id="fm_rg"
                  style={this.styles.input}
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.rg}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                <label style={this.styles.label} htmlFor="fm_rgEmitter">Org. Expedidor</label>
                <Input
                  id="fm_rgEmitter"
                  style={this.styles.input}
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.rgEmitter}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                <label style={this.styles.label} htmlFor="fm_cpf" >CPF</label>
                <InputMask
                  id="fm_cpf"
                  style={this.styles.input}
                  mask="999.999.999-99"
                  className="form-control"
                  type="tel"
                  disabled={this.state.disabledInput}

                  defaultValue={vendaSelecionada.financialManager.cpf}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                <label style={this.styles.label}  htmlFor="fm_dateOfBirth">Data de Nasc.</label>
                <Input
                  id="fm_dateOfBirth"
                  style={this.styles.input}
                  type="date"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.dateOfBirth}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                <label style={this.styles.label} htmlFor="fm_maritalStatus">Estado Civil</label>
                <Input
                  id="fm_maritalStatus"
                  className="form-control"
                  defaultValue={vendaSelecionada.financialManager.maritalStatus}
                  disabled={this.state.disabledInput}
                  />

              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                <label style={this.styles.label} htmlFor="fm_gender">Sexo</label>
                <Input
                  id="fm_gender"
                  className="form-control"
                  defaultValue={(vendaSelecionada.financialManager.gender == 0 ? "Femenino" : "Masculino")}
                  disabled={this.state.disabledInput}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={2}>
                <label style={this.styles.label} htmlFor="fm_cep">CEP
                  <i
                    id="loading_address"
                    style={{ display: 'none', marginLeft: 10, width: 15 }}
                    className="fa fa-spinner fa-spin">
                    &nbsp;
                  </i>
                </label>
                <InputMask
                  id="fm_cep"
                  style={this.styles.input}
                  mask="99.999-999"
                  className="form-control"
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.cep}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                <label style={this.styles.label} htmlFor="fm_addressType">Tipo</label>
              <Input
                id="fm_addressType"
                style={this.styles.input}
                type="text"
                className="form-control"
                value={endereco ? endereco.TipoLogradouro : ''}
                disabled={this.state.disabledInput}
                onChange={() => {}}
              />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={7}>
                <label style={this.styles.label} htmlFor="fm_address">Endereço</label>
                <Input
                  id="fm_address"
                  style={this.styles.input}
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.address}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={1}>
                <label style={this.styles.label} htmlFor="fm_addressNumber">Número</label>
                <Input
                  id="fm_addressNumber"
                  style={this.styles.input}
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.addressNumber}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                <label style={this.styles.label} htmlFor="fm_addressComplement">Complemento</label>
                <Input
                  id="fm_addressComplement"
                  style={this.styles.input}
                  type="text"
                  disabled={this.state.disabledInput}
                  defaultValue={vendaSelecionada.financialManager.addressComplement}
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                <label style={this.styles.label} htmlFor="fm_state">Estado</label>
              <Input
                id="fm_state"
                style={this.styles.input}
                type="text"
                className="form-control"
                value={endereco ? endereco.Uf : ''}
                disabled={this.state.disabledInput}
                onChange={() => {}}
              />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                <label style={this.styles.label} htmlFor="fm_city">Cidade</label>
              <Input
                id="fm_city"
                style={this.styles.input}
                type="text"
                className="form-control"
                value={endereco ? endereco.Municipio : ''}
                disabled={this.state.disabledInput}
                onChange={() => {}}
              />

              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                <label style={this.styles.label} htmlFor="fm_bairro">Bairro</label>

              <Input
                id="fm_bairro"
                style={this.styles.input}
                type="text"
                className="form-control"
                value={endereco ? endereco.Bairro : ''}
                disabled={this.state.disabledInput}
                onChange={() => {}}
              />


              </Grid>
                            
              <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                  <Grid container spacing={24} align-items="center"> {/* Adicionado align-items="center" */}
                  <Grid item xs={8} sm={8} md={8} lg={10}>
                    <h4 style={this.styles.h4}>Documentos Anexados</h4>
                  </Grid>


                </Grid>
              </Grid>
            </Grid>
          </fieldset>     

          {titular && (
            <fieldset style={this.styles.fieldset}>
              <legend style={this.styles.legend}>
                Titular do Plano
              </legend>

              <Grid container spacing={24}>
                <Grid item xs={12} md={6}>
                  <label style={this.styles.label}>Nome</label>
                  <Input
                    style={this.styles.input}
                    disabled
                    defaultValue={`${titular.firstName} `}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <label style={this.styles.label}>Cartão SUS</label>
                  <Input
                    style={this.styles.input}
                    disabled
                    defaultValue={`${titular.susNumber} `}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <label style={this.styles.label}>CPF</label>
                <InputMask
                  id="titular_cpf"
                  style={this.styles.input}
                  mask="999.999.999-99"
                  className="form-control"
                  type="tel"
                  disabled={this.state.disabledInput}
                   defaultValue={`${titular.cpf} || ''}`}
                />                  
                 
                </Grid>

                <Grid item xs={12} md={3}>
                  <label style={this.styles.label}>Data Nasc.</label>
                  <Input
                    style={this.styles.input}
                    type="date"
                    disabled
                    defaultValue={titular.dateOfBirth}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label style={this.styles.label}>Estado Civil</label>
                  <Input
                    style={this.styles.input}
                    disabled
                    defaultValue={titular.maritalStatus}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label style={this.styles.label}>Sexo</label>
                  <Input
                    style={this.styles.input}
                    disabled
                    defaultValue={titular.gender === 0 ? 'Feminino' : 'Masculino'}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <label style={this.styles.label}>Nome da Mãe</label>
                  <Input
                    style={this.styles.input}
                    disabled
                    defaultValue={`${titular.motherName}  || ''}`}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <label style={this.styles.label}>Valor</label>
                  <Input
                    style={this.styles.input}
                    disabled
                    defaultValue={`${titular.valuePlan || ''}`}
                  />
                </Grid>
              </Grid>
            </fieldset>
          )}


          {outrosDependentes.length > 0 && (
            <fieldset style={this.styles.fieldset}>
              <legend style={this.styles.legend}>
                Dependentes
              </legend>

              {outrosDependentes.map((dep, index) => (
                <Grid
                  key={index}
                  container
                  spacing={24}
                  style={{ marginBottom: 20 }}
                >
                  <Grid item xs={12} md={6}>
                    <label style={this.styles.label}>Nome</label>
                    <Input
                      style={this.styles.input}
                      disabled
                      defaultValue={`${dep.firstName} || ''}`}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label style={this.styles.label}>Cartão SUS</label>
                    <Input
                      style={this.styles.input}
                      disabled
                      defaultValue={`${dep.susNumber} || ''}`}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <label style={this.styles.label}>CPF</label>
                    <InputMask
                      id="titular_cpf"
                      style={this.styles.input}
                      mask="999.999.999-99"
                      className="form-control"
                      type="tel"
                      disabled={this.state.disabledInput}
                      defaultValue={dep.cpf}
                    />                     

                  </Grid>

                  <Grid item xs={12} md={3}>
                    <label style={this.styles.label}>Data Nasc.</label>
                    <Input
                      style={this.styles.input}
                      type="date"
                      disabled
                      defaultValue={dep.dateOfBirth}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <label style={this.styles.label}>Estado Civil</label>
                    <Input
                      style={this.styles.input}
                      disabled
                      defaultValue={dep.maritalStatus || '—'}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <label style={this.styles.label}>Sexo</label>
                    <Input
                      style={this.styles.input}
                      disabled
                       defaultValue={dep.gender === 0 ? 'Feminino' : 'Masculino'}
                    />
                  </Grid>  
                  <Grid item xs={12} md={3}>
                    <label style={this.styles.label}>Nome da Mãe</label>
                    <Input
                      style={this.styles.input}
                      disabled
                       defaultValue={dep.motherName || '—'}
                    />
                  </Grid> 
                  <Grid item xs={12} md={3}>
                    <label style={this.styles.label}>Valor</label>
                    <Input
                      style={this.styles.input}
                      disabled
                       defaultValue={dep.valuePlan || '—'}
                    />
                  </Grid>                                                       
                </Grid>
              ))}
            </fieldset>
          )}
<fieldset style={this.styles.fieldset}>
  <legend style={this.styles.legend}>
    Info. Plano
  </legend>

  <Grid container spacing={24}>
    <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
      <label style={this.styles.label } htmlFor='fm_nome_plano'>Nome</label>
      <Input style={this.styles.input} id="fm_nome_plano" type="text" disabled
        defaultValue={vendaSelecionada.financialManager.plans.name} />
    </Grid>
    <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
      <label style={this.styles.label} htmlFor='fm_responsibility'>Valor Total Mensal</label>
      <Input
        id="fm_responsibility"
        style={this.styles.input}
        type="text"
        disabled
        defaultValue={vendaSelecionada.financialManager.responsibility}
      />
    </Grid>
    <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
      <label style={this.styles.label} htmlFor='fm_data_adesao'>Data de Adesão</label>
      <Input style={this.styles.input} id="fm_data_adesao" type="text" disabled
        defaultValue={this.formatarDataParaBR(vendaSelecionada.financialManager.dateSignatureContract)} />
    </Grid>

    <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
      <label style={this.styles.label} htmlFor='fm_contractNumberS4'>Cód. pagemento</label>
      <Input style={this.styles.input} 
        type="text" 
        id="fm_contractNumberS4"
        disabled
        defaultValue={vendaSelecionada.financialManager.contractNumberS4} />
    </Grid>


  </Grid>
</fieldset>     
          
                  <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                      Info. Corretora
                    </legend>

                    <Grid container spacing={24}>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                        <label style={this.styles.label} htmlFor='id_corretora'>Corretora</label>
                        <Input 
                            style={this.styles.input}
                            id="id_corretora" 
                            type="text" 
                            disabled
                            defaultValue={vendaSelecionada.broker.user.name} />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={8} lg={8}>
                        <label style={this.styles.label} htmlFor='id_vendedor'>Vendedor</label>
                        <Input style={this.styles.input} id='id_vendedor' type="text" disabled
                          defaultValue={vendaSelecionada.salesman.user.name} />
                      </Grid>
                      <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                        <label style={this.styles.label}  htmlFor='id_codigo'>Código</label>
                        <Input style={this.styles.input} id='id_codigo' type="text" disabled
                          defaultValue={vendaSelecionada.salesman.codeS4} />
                      </Grid>
                    </Grid>
                  </fieldset>
          {/** Financeiro */}
          { 
            vendaSelecionada.financialManager.cardNumber.length > 0 ? (
          <fieldset style={this.styles.fieldset}>
            <legend style={this.styles.legend}>
              Dados Financeiros
            </legend>

            <Grid container spacing={24}>
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                <label style={this.styles.label}  htmlFor='id_dia_vencimento'>Dia do Vencimento</label>
                <InputMask                          
                  style={this.styles.input}
                  className="form-control"     
                  id='id_dia_vencimento'                     
                  type="tel"
                      defaultValue={vendaSelecionada.financialManager.cardDayExpiration}
                  disabled                        
                />
              </Grid>                      
            </Grid>    

            <Grid container spacing={24}>
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                <label style={this.styles.label}  htmlFor='fm_cardNumber'>Cartão de Crédito</label>
                <InputMask
                  id="fm_cardNumber"
                  style={this.styles.input}
                  className="form-control"
                  //mask="9999.9999.9999.9999"
                  type="tel"
                  defaultValue={"XXXX.XXXX.XXXX."+vendaSelecionada.financialManager.cardNumber.slice(-4)}
                  disabled
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={5}>
                <label style={this.styles.label}  htmlFor='fm_cardHolderName'>Nome do Titular do Cartão</label>
                <Input
                  id="fm_cardHolderName"
                  style={this.styles.input}
                  className="form-control"
                  type="text"
                  defaultValue={vendaSelecionada.financialManager.cardHolderName}
                  disabled
                />
              </Grid>
              <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                <label style={this.styles.label} htmlFor='fm__cardFlag' >Bandeira</label>
                <Input
                  id="fm__cardFlag"
                  type="text"
                  className="form-control"
                  defaultValue={vendaSelecionada.financialManager.cardFlag}
                  disabled
                >

                </Input>
              </Grid>
            
              <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                <label style={this.styles.label} htmlFor='fm_cardValidity'>Validade</label>
                <InputMask
                  id="fm_cardValidity"
                  style={this.styles.input}
                  className="form-control"
                  mask="99/9999"
                  type="tel"                      
                  defaultValue={vendaSelecionada.financialManager.cardValidity}
                  disabled
                />
              </Grid>
            </Grid>
            <Grid container spacing={24}>
              
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                <br/>
                <label style={this.styles.label}>Cartão pertencente a algum usuário do plano? </label>
                <Input
                  id="fm_cardHolderName1"
                  style={this.styles.input}
                  className="form-control"
                  type="text"
                  defaultValue= { vendaSelecionada.financialManager.cpfCard == undefined ? ('NÃO INFORMADO') 
                  : ( vendaSelecionada.financialManager.cpfCard != '' ? ('NÃO') 
                  : ('SIM') ) }
                  disabled
                />                       

              </Grid>    
              <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
              { vendaSelecionada.financialManager.cpfCard != '' && vendaSelecionada.financialManager.cpfCard != undefined ? (
                  [
                    <br/>,
                    <label style={this.styles.label}>CPF do Dono do Cartão </label>,
                    <Input
                    id="fm_cardHolderName2"
                    style={this.styles.input}
                    className="form-control"
                    type="text"
                    defaultValue={vendaSelecionada.financialManager.cpfCard}
                    disabled
                  />                             
                  ]

                  ):('' )
                } 

              </Grid>                                            
            </Grid>                     
          </fieldset>
            ) : (
          <fieldset style={this.styles.fieldset}>
            <legend style={this.styles.legend}>
              Dados Financeiros
            </legend>

            <Grid container spacing={24}>
              <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                Pagamento por boleto
              </Grid>
            </Grid>
          </fieldset>
            )
          }
          {/* Para o campo de observação */}
          <fieldset style={this.styles.fieldset}>
            <label htmlFor='sl_observation' style={this.styles.legend}>
              Observações
            </label>

            <Grid container spacing={24}>
                {
                  localStorage.getItem('dental_y') == 'SALESMAN' ? (
              <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                <Input
                  id="sl_observation"
                  style={{width:'100%', height: 100}}
                  type="textarea"
                  disabled={this.state.disabledInput}
                  
                  defaultValue= {vendaSelecionada.observation}
                />
              </Grid>
                    ) : (
              <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                {vendaSelecionada.observation}
              </Grid>
                    )
                }
            </Grid>
          </fieldset>  
          {/* Para as pendências */
            vendaSelecionada.status == 'PENDENTE' ? (
            <fieldset style={this.styles.fieldset}>
              <legend style={this.styles.legend}>
                Pendência
              </legend>

              <Grid container spacing={24}>
                <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                  &nbsp;
                </Grid>
                <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>  
                  <Input
                    style={{ margin: '10px auto 0 auto'}}
                    type="select"
                    className="form-control"
                    disabled
                    defaultValue={vendaSelecionada.pendencyId}
                  >
                    {this.state.pendencyList.map((item, index) =>
                      <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
                    )}
                  </Input>
                </Grid>
                <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                  &nbsp;
                </Grid>
              </Grid>
            </fieldset>
            ) : ('')
          }                 
    </Dialog>
  );
}


fecharDialogVenda() {
  this.setState({
    dialogVendaAberto: false,
    vendaSelecionada: null
  });
}

// Descontinuado
obterDescricaoMunicipio(idMunicipio, idUF) {
  const { cacheMunicipios } = this.state;
  const chaveMunicipio = String(idMunicipio);

  // ✅ cache
  if (cacheMunicipios[chaveMunicipio]) {
    return Promise.resolve(cacheMunicipios[chaveMunicipio]);
  }

  const dataPost = {
    idUF: idUF
  };

  return axios.post(
    urlBase.loopBack + 'APIS4s/Municipios',
    dataPost
  )
  .then(res => {
    const municipios = res.data || [];

    const novoCache = { ...cacheMunicipios };

    municipios.forEach(m => {
      novoCache[String(m.Id)] = m.Nome;
    });

    this.setState({ cacheMunicipios: novoCache });

    return novoCache[chaveMunicipio] || '-';
  })
  .catch(err => {
    console.error('Erro ao buscar municípios', err);
    return '-';
  });
}

resolverSexo(idSexo) {
  const mapa = {
    0 : 'Feminino',
    1 : 'Masculino'
  };

  return mapa[idSexo] || '-';
}


  render() {


        return (
          <div id="resume_content">
              <style>{tableStyles}</style>

            <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', marginBottom: '25px' }}>
                VENDAS POR VENDEDOR
            </div>

            {this.state.snackbar && (
              <Snackbar
                open={this.state.snackbar.open}
                message={this.state.snackbar.msg}
                autoHideDuration={4000}
                onRequestClose={this.snackbarRequestClose.bind(this)}
              />
            )}


            
              {this.state.modoTela === 'LISTA' && (
                <div>
                  
            <Row>
              <Col xs="12">
                <p onClick={this.goBack.bind(this)} style={{ cursor: 'pointer' }}>
                  <FaStepBackward /> Voltar
                </p>
              </Col>
            </Row>              
                  
                  <Row style={{ marginBottom: '20px' }}>
                    <Col xs="12" md="4">
                      <label>Data inicial:</label>
                      <input
                        type="date"
                        className="form-control"
                        value={this.state.dataInicio}
                        onChange={(e) => this.setState({ dataInicio: e.target.value })}
                      />
                    </Col>

                    <Col xs="12" md="4">
                      <label>Data final:</label>
                      <input
                        type="date"
                        className="form-control"
                        value={this.state.dataFim}
                        onChange={(e) => this.setState({ dataFim: e.target.value })}
                      />
                    </Col>

                    <Col xs="12" md="3" style={{ marginTop: '24px' }}>
                      <button
                        onClick={this.buscarRelatorio}
                        style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                      >
                        Pesquisar
                      </button>
                    </Col>
                  </Row>

                  {this.state.carregandoDados && (
                    <p style={{ color: '#007bff', fontWeight: 'bold' }}>
                      <i className="fa fa-refresh fa-spin"></i> Buscando dados...
                    </p>
                  )}

                  {this.state.mensagemErro && (
                    <div style={{ color: '#721c24', backgroundColor: '#f8d7da', padding: '8px', borderRadius: '4px' }}>
                      {this.state.mensagemErro}
                    </div>
                  )}

                  <Row style={{ marginBottom: '10px' }}>
                    <Col xs="12">
                      <button
                        onClick={() => this.exportarCSV()}
                        style={{
                          ...Styles.buttonSuccess,
                          backgroundColor: '#0f766e',
                          textTransform: 'none',
                          fontWeight: 'bold'
                        }}
                      >
                        Exportar CSV
                      </button>
                    </Col>
                  </Row>

                  <Row style={{ marginBottom: '15px' }}>
                    <Col xs="12" md="4">
                      <label>Filtrar por vendedor:</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Digite o nome do vendedor"
                        value={this.state.filtroVendedor}
                        onChange={(e) =>
                          this.setState({ 
                            filtroVendedor: e.target.value,
                            paginaAtual: 1
                          })
                        }
                      />
                    </Col>
                  </Row>

                  {this.renderTabelaUnica()}
                </div>
              )}

            {this.state.modoTela === 'DETALHE' && this.renderTabelaVendasDetalhadas()}
            {this.renderDialogDetalheVenda()}
          </div>
        );
    
  }

}

const styles = {
  th: {
    textAlign: 'left',
    borderBottom: '1px solid #ccc',
    padding: '6px'
  },
  td: {
    padding: '6px',
    borderBottom: '1px dotted #eee'
  }
};
    const statusStyles = {
      'ATIVO': {
        bg: Colors.statusAtivoBg,
        color: Colors.statusAtivoText
      },
      'CANCELADO': {
        bg: Colors.statusCanceladoBg,
        color: Colors.statusCanceladoText
      },
      'PENDENTE': {
        bg: Colors.statusPendenteBg,
        color: Colors.statusPendenteText
      },
      'EM VALIDAÇÃO': {
        bg: Colors.statusValidacaoBg,
        color: Colors.statusValidacaoText
      },
      'PAGAMENTO PENDENTE': {
        bg: Colors.statusPagamentoPendenteBg,
        color: Colors.statusPagamentoPendenteText
      }
    };
export default VendasPorVendedor;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/Salesmans/VendasPorVendedor.js
 **/